<template>
  <transition name="fade">
    <div class="col-xs-6 col-sm-12 retouching-package-detail__column">
      <div
        :class="classes"
        @click="$emit('retouching-package-click')"
      >
        <div class="retouching-package-detail__head">
          <div class="row">
            <div class="col-xs-12 col-sm-10">
              <div
                :class="nameClasses(retouchingPackage.CatalogPackage.RetailName)"
              >{{ retouchingPackage.CatalogPackage.RetailName }}</div>
            </div>
            <div class="hidden-xs col-sm-2">
              <div
                v-if="showExpansionArrows"
                :class="expandIconClasses"
              >
                <span
                  v-if="!isSelected"
                  class="fa fa-chevron-right"
                />
                <span
                  v-if="isSelected"
                  class="fa fa-chevron-down"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isSelected"
          class="row hidden-xs"
        >
          <div class="col-xs-12">
            {{ retouchingPackage.CatalogPackage.RetailSummary }} <strong>{{ retouchingPackage.EffectiveCostFormatted }}</strong>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RetouchingPackage',
  props: {
    retouchingPackage: { type: Object, default: null },
    isSelected: { type: Boolean, default: false },
    totalNumberRetouchingPackages: { type: Number, default: 0 }
  },
  computed: {
    classes () {
      return {
        'retouching-package-detail': true,
        'retouching-package-detail--open': this.isSelected
      }
    },
    expandIconClasses () {
      return {
        'retouching-package-detail__expand-icon': true,
        'retouching-package-detail__expand-icon--open': this.isSelected
      }
    },
    showExpansionArrows () {
      return this.totalNumberRetouchingPackages > 1
    }
  },
  methods: {
    nameClasses (name) {
      return {
        'retouching-package-detail__name': true,
        'retouching-package-detail__name--long': name.length >= 24
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.retouching-package-detail {
  background-color: $grad-color-blue;
  border: 2px solid $grad-color-blue;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  text-align: center;
  padding: 4px;
  margin: 0 0 10px 0;

  &--open {
    background-color: transparent;
    color: #000;
  }

  &__column {
    padding-left: 6px;
    padding-right: 6px;
  }

  &__head {
    font-weight: 900;
    margin: 0;
    padding: 0;
  }

  &__expand-icon {
    color: #fff;
    text-align: right;

    &--open {
      color: $grad-color-blue;
    }
  }

  &__name {
    padding: 0 7px;

    &--long {
      padding: 0;
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    margin-bottom: 20px;
    padding: 20px 20px 10px 20px;
    font-size: 16px;
    text-align: left;

    &--open {
      padding: 20px;
    }

    &__head {
      margin-bottom: 10px;
    }

    &__name {
      padding: 0;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &__column {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/RetouchingModal/RetouchingPackageDetail.vue